import React, { useCallback, useState } from 'react';
import styled from '@emotion/styled';

import { InquirySteps, InquiryStepOne } from '.';
import { Container, InputForm } from './inquryStyles';
import { ExtraBoldText, RegularText } from '@/components/text';
import { RequiredMark } from '@/components/input/InputBasic';
import { EventForm } from '@/pages/event';
import { ArenaForm } from '@/pages/arena';
import { ARENA_SELECTED, EVENT_SELECTED } from '@/constants/apiUrls';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { zodEventType } from '@/utils/zodValidation';

const Wrapper = styled.div(() => ({
  width: '100%',
  maxWidth: '58rem',
}));

const TextWrapper = styled.div(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '2rem 0',
  marginBottom: '2rem',
  whiteSpace: 'break-spaces',
  textAlign: 'center',
}));

const MandatoryFields = styled.div(() => ({
  width: '100%',
  marginBottom: '1.4rem',
}));
const Inquiry = () => {
  const [step, setStep] = useState(0);
  const [category, setCategory] = useState('');
  const [eventType, setEventType] = useState('0');

  const {
    control,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(zodEventType),
    defaultValues: {
      business_key: '1',
      event_type_key: '1',
    },
  });

  const onTypeSubmit = useCallback(
    async (data) => {
      setCategory(data.business_key);
      setEventType(data.event_type_key);

      setStep((prev) => prev + 1);
    },
    [setStep, setCategory, setEventType]
  );

  return (
    <>
      <Container>
        <TextWrapper>
          <ExtraBoldText id="lang-event-inquiry" fontSize="4.8rem" />

          <RegularText id="lang-inquiry-description" secondary />
        </TextWrapper>

        {(step === 1 || step === 2) && <InquirySteps step={step} />}

        <Wrapper>
          <MandatoryFields>
            <RegularText fontSize="1.6rem">
              <RequiredMark>*</RequiredMark>{' '}
              <RegularText id="lang-mandatory-fields" fontSize="1.6rem" />
            </RegularText>
          </MandatoryFields>

          {step === 0 && (
            <InputForm onSubmit={handleSubmit(onTypeSubmit)}>
              <InquiryStepOne control={control} errors={errors} watch={watch} setValue={setValue} />
            </InputForm>
          )}

          {category === ARENA_SELECTED && (
            <ArenaForm step={step} setStep={setStep} eventType={eventType} />
          )}

          {category === EVENT_SELECTED && (
            <EventForm step={step} setStep={setStep} eventType={eventType} />
          )}
        </Wrapper>
      </Container>
    </>
  );
};

export default Inquiry;
